import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import _ from 'lodash'
import {CooperationMember, CooperationPartner, CooperationProf} from './store/modules/cooperation'
import {SET_PROFILE} from "./store/mutations/main";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        CooperationMember,
        CooperationPartner,
        CooperationProf
    },
    state: {
        api: "https://profclass.mskobr.ru",
        //api: "http://profclass.loc",
        apiProjectsEO: "/api/statuses/eo.json",
        apiStatuses: "/api/statuses/eo.json",
        apiResponsibles: "/api/responsible.json",
        apiAddressesEquipment: "/api/address-equipments.json",
        apiDataSingle: "/api/data-singles.json",
        apiMediaEquipment: "/api/media-equipments.json",
        apiPhotosEquipment: "/api/equipment-files.json",
        apiTeachers: "/api/teachers.json",
        apiCourses: "/api/courses.json",
        apiEventsPupils: "/api/events.json",
        apiEventsTeachers: "/api/events-teachers.json",
        apiEventsEo: "/api/events-eos.json",
        apiCooperation: "/api/cooperations.json",
        apiMediaCooperationPartner: "/api/media-partners.json",
        apiGraduates: "/api/graduates.json",
        apiCadetResponsible: "/api/cadet/recipient/site/public.json",
        apiCadetCooperation: "/api/cadet/cooperationcadet/site/public.json",
        apiCadetAcademic: "/api/cadet/academicachievement/site/public.json",
        apiCadetSport: "/api/cadet/sport/site/public.json",
        apiCadetConcurs: "/api/cadet/concurs/site/public.json",
        apiCadetCourse: "/api/cadet/coursecadet/site/public.json",
        apiCadetEventTeacher: "/api/cadet/eventteacher/site/public.json",
        apiCadetEvent: "/api/cadet/event/site/public.json",

        //---- api GO
        apiGo: "https://api-typalsites.mskobr.ru",
        apiGoCountPupils: "/api/v0/city_project/",

        eoId: false,
        type: false,
        statuses: false,
        status: false,
        profile: false,
        goApiToken:false,
        currentProject: false,
        numberStudents: false,
    },


    mutations: {
        setEoId(state, value) {
            state.eoId = value
        },
        setType(state, value){
            state.type = value
        },
        setStatuses(state, value){
            state.statuses = value
        },
        setStatus(state, value){
            state.status = value
        },
        [SET_PROFILE](state, value){
            state.profile = value
        },
        setCurrentProject(state, value){
            state.currentProject = value
        },
        setNumberStudents(state, value){
            state.numberStudents = value
        },
        setGroApiToken(state, value){
            state.goApiToken = value
        }
    },


    actions: {
        getStatus({state, commit}){
            const path = state.api + state.apiStatuses + "?eoId=" + state.eoId
            Axios({
                method: "get",
                url: path,
            }).then((response) => {
                if (response.status == 200 && response.data.result == "success") {
                    commit('setStatuses', response.data.data)
                    commit('setGroApiToken', response.data.token)
                    let project = _.find(response.data.data, {"projectType": state.type});
                    if (project) {
                        commit('setCurrentProject', project)
                        commit(SET_PROFILE, project.profile)
                        let status = project.status;
                        commit('setStatus', status)
                    }

                }
            })
        },
        getNumberStudents({state, commit}){
            return new Promise((resolve, reject) => {
                let path = state.api + '/api/students.json?eoId=' + state.eoId;
                Axios({
                    method: 'GET',
                    url: path
                }).then((res) => {
                    if(res.data.result == 'success'){
                        commit('setNumberStudents', res.data.data)
                        resolve(res)
                    }else{
                        reject(res)
                    }
                })
            })

        },
    }
})
